import React, { useState, useEffect } from 'react';
import { TextField, Button, Container, Typography, FormControlLabel, Checkbox } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import config from '../config';

function PeriodoForm() {
  const [periodo, setPeriodo] = useState({
    anio: '',
    mes: '',
    contable: false,
  });
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      fetchPeriodo(id);
    }
  }, [id]);

  const fetchPeriodo = async (id) => {
    try {
      const response = await axios.get(`${config.API_BASE_URL}/api/periodos/${id}`, {
        headers: { Authorization: `Bearer ${user.token}` }
      });
      setPeriodo(response.data);
    } catch (error) {
      console.error('Error al obtener el periodo:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setPeriodo((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    try {
      if (id) {
        await axios.put(`${config.API_BASE_URL}/api/periodos/${id}`, periodo, {
          headers: { Authorization: `Bearer ${user.token}` }
        });
      } else {
        await axios.post(`${config.API_BASE_URL}/api/periodos`, periodo, {
          headers: { Authorization: `Bearer ${user.token}` }
        });
      }
      navigate('/home/periodos');
    } catch (error) {
      console.error('Error al guardar el periodo:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Typography variant="h4" gutterBottom>
        {id ? 'Editar Periodo' : 'Crear Periodo'}
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Año"
          variant="outlined"
          fullWidth
          margin="normal"
          name="anio"
          value={periodo.anio}
          onChange={handleChange}
          required
        />
        <TextField
          label="Mes"
          variant="outlined"
          fullWidth
          margin="normal"
          name="mes"
          value={periodo.mes}
          onChange={handleChange}
          required
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={periodo.contable}
              onChange={handleChange}
              name="contable"
              color="primary"
            />
          }
          label="Contable"
        />
        <Button variant="contained" color="primary" type="submit" fullWidth style={{ marginTop: '20px' }} disabled={loading}>
          {loading ? 'Guardando...' : (id ? 'Guardar Cambios' : 'Crear Periodo')}
        </Button>
      </form>
    </Container>
  );
}

export default PeriodoForm;
